import React from "react";
import { useTranslation } from "react-i18next";
import EditIcon from "resources/images/EditIcon.png";
import Button from "components/basic/button";

interface EditSectionButtonProps {
  label: string;
  onClick: () => void;
}

const EditSectionButton: React.FC<EditSectionButtonProps> = ({
  label,
  onClick,
}) => {
  const { t } = useTranslation("services");

  return (
    <Button
      variant="text"
      onClick={onClick}
      // Button sets fontWeight inline and inline beats sx, so it stays here.
      style={{ fontWeight: "bold" }}
      sx={{
        fontSize: { xs: "0.95rem", sm: "1.125rem" },
        // Long section names have to wrap rather than widen the column.
        whiteSpace: "normal",
        lineHeight: 1.3,
      }}
      endAdornment={
        <img src={EditIcon} alt={t("wizard.edit")} width={20} height={20} />
      }
    >
      {label}
    </Button>
  );
};

export default EditSectionButton;
